import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import { ConfirmTrashCallable } from "@/action-dialog/callables";
import type { Workspace } from "@cohesive/api-client";
import toast from "react-hot-toast";

export interface MoveWorkspaceToTrashParams {
  workspace: Workspace;
  deleteWorkspace: {
    mutateAsync: (workspaceId: string) => Promise<void>;
  };
  /** Extra side effects after a successful trash (toast is always shown). */
  onSuccess?: (workspace: Workspace) => void | Promise<void>;
}

export function runMoveWorkspaceToTrashWorkflow(
  params: MoveWorkspaceToTrashParams,
): Promise<boolean> {
  const { workspace, deleteWorkspace, onSuccess } = params;

  return withActionDialogLock(() =>
    ConfirmTrashCallable.call({
      kind: "workspace",
      name: workspace.name,
      mutationFn: async (call) => {
        await deleteWorkspace.mutateAsync(workspace.id);
        toast.success("Archived.");
        await onSuccess?.(workspace);
        call.end(true);
      },
    }),
  );
}
